export default __webpack_public_path__ + "static/media/team-2.3fa639d0.png";